import React from 'react';
import UserProductUncollapsed from './UserProductUncollapsed';
import ResultsProductCollapsed from './ResultsProductCollapsed';
import { quizResultProducts } from '../lib/quizSteps';
import PropTypes from 'prop-types';
import Row from 'kepler/lib/components/Row';

const getUserProductView = options => {
  const { toggleProduct, location, fptiHelper, product, productName } = options;
  if (product.isCollapsed) {
    return (
      <ResultsProductCollapsed
        product={product}
        toggleProduct={toggleProduct}
        productName={productName}
        type="userProducts"
      />
    );
  }
  const resultData = quizResultProducts(productName);
  return (
    <UserProductUncollapsed
      toggleProduct={toggleProduct}
      productName={productName}
      resultData={resultData}
      location={location}
      isCompleted={product.isProductCompleted}
      fptiHelper={fptiHelper}
    />
  );
};

const UserProductView = props => {
  const { userProducts } = props;
  return (
    <div>
      {Object.keys(userProducts).map(productName => {
        let product = userProducts[productName];
        return (
          <Row
            key={productName}
            className={`results-user ${
              product.isCollapsed ? 'results-user-mobile' : ''
            }`}
            style={{ padding: product.isCollapsed ? '0px' : '24px' }}
          >
            {getUserProductView({ ...props, product, productName })}
          </Row>
        );
      })}
    </div>
  );
};

UserProductView.propTypes = {
  userProducts: PropTypes.object,
  toggleProduct: PropTypes.func,
  location: PropTypes.object,
  fptiHelper: PropTypes.object
};

export default UserProductView;
